import React, { useEffect, useState } from 'react';
import { asText } from '@lib/prismic/util/document';
import { Designer } from '@graphql/Designer/queries/availableDesigners.graphql';
import Loader from '@components/shared/Loader/Loader';
import If from '@components/shared/conditional/If/If';
import useBookDesignerAndProceedToPurchase from '@components/pages/DesignerProfile/DesignerProfileAdmin/PreferButton/utils';
import ShowAt from '@components/shared/conditional/ShowAt';
import HideAt from '@components/shared/conditional/HideAt';
import { v4 as uuidv4 } from 'uuid';
import { useTheme } from '@components/theme';
import classnames from 'classnames';
import SeeAllLink from '@components/pages/InteriorDesignersLocationPages/shared/SeeAllLink/SeeAllLink';
import { IPrismicText } from '../../pages/InteriorDesigners/InteriorDesigners';
import ReadMore from '../../pages/InteriorDesigners/shared/ReadMoreContainer/ReadMoreContainer';
import Card from './Card/Card';

import styles from './Designers.module.scss';

interface IDesignersProps {
  className?: string;
  designers: Designer[];
  cities?: string[];
  title?: IPrismicText[];
  subtitle?: IPrismicText[];
  eyebrow?: IPrismicText[];
  isLoading?: boolean;
  displayAllDesignersLink?: boolean;
}

const Designers = ({
  className,
  designers,
  cities,
  subtitle,
  title,
  eyebrow = [],
  isLoading = false,
  displayAllDesignersLink = false,
}: IDesignersProps) => {
  const theme = useTheme();
  const [listId, setListId] = useState(uuidv4());
  const {
    bookDesignerAndProceedToPurchase,
    isChangingDesigner
  } = useBookDesignerAndProceedToPurchase();

  useEffect(() => {
    setListId(uuidv4());
  }, [designers]);

  return (
    <div className={classnames(styles.Container, theme.styles.Body, className)}>
      <div className={ styles.Wrapper }>
        <div>
          <If condition={!!asText(eyebrow)}>
            <p className={styles.Eyebrow}>{ asText(eyebrow) }</p>
          </If>
          {!!title && !!asText(title) && (
            <h2 className={classnames(theme.styles.Title1, styles.Title)}>{ asText(title) }</h2>
          )}
          <If condition={!!subtitle && !!asText(subtitle)}>
            <ReadMore
              className={classnames(styles.Subtitle)}
              contentClassName={styles.ReadMoreContent}
              text={ asText(subtitle!) }
            />
          </If>
        </div>
        <If condition={displayAllDesignersLink}>
          <ShowAt breakpoint={'desktop'}>
            <SeeAllLink
              link="/interior-designers"
              text="See all Interior Designers"
              arrow
            />
          </ShowAt>
        </If>
      </div>

      <div className={styles.Cards}>
        {designers.map((designer: Designer, index) => (
          <Card
            cities={cities}
            key={designer.id}
            designer={designer}
            CTAHandler={() => {
              bookDesignerAndProceedToPurchase({ ...designer, position: index, listId });
            }}
          />
        ))}
      </div>
      <If condition={isLoading || isChangingDesigner}>
        <div className={styles.LoadingLogo}><Loader /></div>
      </If>

      <If condition={displayAllDesignersLink}>
        <HideAt breakpoint={'desktop'}>
          <div className={ styles.More }>
            <SeeAllLink
              link="/interior-designers"
              text="See all Interior Designers"
            />
          </div>
        </HideAt>
      </If>
    </div>
  );
};

export default Designers;
